import { VariantFinishEnum, VariantProductEnum } from "@sorcery/db";
import type { BaseVariantTypeForSorting } from "./sorting";

export const finishSlugMap = {
  [VariantFinishEnum.Standard]: "_s",
  [VariantFinishEnum.Foil]: "_f",
};

export const productSlugMap = {
  [VariantProductEnum.Booster]: "_b",
  [VariantProductEnum.Preconstructed_Deck]: "_d",
  [VariantProductEnum.Box_Topper]: "_bt",
  [VariantProductEnum.Pledge_Pack]: "_pp",
  [VariantProductEnum.Draft_Kit]: "_dk",
  [VariantProductEnum.Store_Kit]: "_sk",
  [VariantProductEnum.Promo]: "_p",
};

const finishTextMap = {
  [VariantFinishEnum.Standard]: "",
  [VariantFinishEnum.Foil]: " (Foil)",
};

const finishSnippetMap = {
  [VariantFinishEnum.Standard]: "",
  [VariantFinishEnum.Foil]: " (F)",
};

const productTextMap = {
  [VariantProductEnum.Booster]: "",
  [VariantProductEnum.Preconstructed_Deck]: " | Preconstructed Deck",
  [VariantProductEnum.Box_Topper]: " | Box Topper",
  [VariantProductEnum.Pledge_Pack]: " | Pledge Pack",
  [VariantProductEnum.Draft_Kit]: " | Draft Kit",
  [VariantProductEnum.Store_Kit]: " | Store Kit",
  [VariantProductEnum.Promo]: " | Promo",
};

const productSnippetMap = {
  [VariantProductEnum.Booster]: "",
  [VariantProductEnum.Preconstructed_Deck]: " | Deck",
  [VariantProductEnum.Box_Topper]: " | Topper",
  [VariantProductEnum.Pledge_Pack]: " | Pack",
  [VariantProductEnum.Draft_Kit]: " | DK",
  [VariantProductEnum.Store_Kit]: " | SK",
  [VariantProductEnum.Promo]: " | Promo",
};
export const getVariantTitle = (variant: BaseVariantTypeForSorting) =>
  `${variant.setCard.set.name}${
    productTextMap[variant.product as VariantProductEnum]
  }${finishTextMap[variant.finish as VariantFinishEnum]}`;

export const getVariantSnippet = (variant: BaseVariantTypeForSorting) =>
  `${variant.setCard.set.name}${
    productSnippetMap[variant.product as VariantProductEnum]
  }${finishSnippetMap[variant.finish as VariantFinishEnum]}`;
